import React from 'react';
import NdcInstituteLogo from '../../static/logo-ndc-institute.svg?react';

export type LogoProps = {
	className?: string;
};

export default function Logo(props: LogoProps) {
	const { className } = props;

	return (
		<div className={`Logo ${className ?? ''}`}>
			<NdcInstituteLogo className="Logo__full" />
			{/* Wheel only, for the collapsed sidebar. */}
			<img className="Logo__icon" src="/images/logo-icon.png" alt="" aria-hidden />
		</div>
	);
}
